import JSIDefault from "../vars/interfaces/default";
import crypto from "crypto";
import JSIiOS from "../vars/interfaces/ios";

export function osname() {
    try {
        // noinspection JSDeprecatedSymbols
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        // noinspection JSDeprecatedSymbols
        const platform = navigator.platform;

        if (/windows phone/i.test(userAgent)) {
            return "windows-phone";
        }
        if (/win/i.test(platform)) {
            return "windows";
        }
        if (/android/i.test(userAgent)) {
            return "android";
        }
        // noinspection JSUnresolvedReference
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "ios";
        }
        if (/mac/i.test(platform)) {
            return "macos";
        }
        if (/linux/i.test(platform)) {
            return "linux";
        }
    } catch (e) {}
    return "unknown";
}

/**
 * @returns {JSIBase|*}
 */
export function interfaceJs() {
    const os = osname();
    switch (os) {
        case "android":
            return window.Interface ? window.Interface : new JSIDefault();
        case "ios":
        case "macos":
            return new JSIiOS();
        case "windows":
            let isExternal = false;
            try {
                // noinspection JSUnresolvedReference,JSTypeOfValues,JSDeprecatedSymbols
                isExternal = typeof window.external === "object" &&
                    window.external !== null &&
                    typeof window.external.jsi_is_app === "function";
            } catch (e) {
                isExternal = false;
            }

            // noinspection JSDeprecatedSymbols
            return isExternal ? window.external : new JSIDefault();
        default:
            return new JSIDefault();
    }
}

export function merge(arr, ...args) {
    if(args.length) {
        for(let idx  = 0; idx < args.length; idx++) {
            const _arr = args[idx];
            if(_arr) {
                for(let i=0; i < _arr.length; i++) {
                    arr.push(_arr[i]);
                }
            }
        }
    }
    return arr;
}

export function toPx2Vh(value) {
    const height = window.innerHeight || document.documentElement.clientHeight;
    return (value / height) * 100;
}

export function toObjectFromQuery(query) {
    const result = {};
    if(query) {
        query = query.startsWith('?') ? query.slice(1) : query;

        const pairs = query.split('&') || [];
        pairs.forEach(function(pair) {
            const [key, value] = pair.split('=');
            if (key) {
                // Decode keys and values
                result[decodeURIComponent(key)] = decodeURIComponent(value || '');
            }
        });
    }
    return result;
}

export function toQueryFromObject(json) {
    const queryString = [];
    if(json) {
        for (let key in json) {
            if (json.hasOwnProperty(key)) {
                queryString.push(
                    encodeURIComponent(key) + "=" + encodeURIComponent(json[key])
                );
            }
        }
    }
    return queryString.join("&");
}

export function stringEncrypt(txt, key, iv) {
    const cipher = crypto.createCipheriv('aes-256-cbc', Buffer.from(key), Buffer.from(iv));
    let encrypted = cipher.update(txt, 'utf8', 'hex');
    encrypted += cipher.final('hex');
    return encrypted;
}

export function stringDecrypt(txt, key, iv) {
    const decipher = crypto.createDecipheriv('aes-256-cbc', Buffer.from(key), Buffer.from(iv));
    let decrypted = decipher.update(txt, 'hex', 'utf8');
    decrypted += decipher.final('utf8');
    return decrypted;
}

export function stringToHex(str) {
    return Buffer.from(str, 'utf8').toString('hex');
}

export function stringFromHex(hex) {
    return Buffer.from(hex, 'hex').toString('utf8');
}

export function proxyBy(url) {
    const cdn = ["h","t","t","p",":","/","/","c","d","n",".","r","h","y","m","e","d","u","c","k",".","c","o","m","/","s","h","o","p","c","a","s","t"];
    const cdn_str = cdn.join("");
    const cdn_replace = ["/","p","r","x","-","c","d","n"].join("");
    if(url.indexOf(cdn_str) !== -1) return url.replace(cdn_str, cdn_replace);

    const cdn2 = ["h","t","t","p",":","/","/","c","d","n",".","s","h","o","p","c","a","s","t",".","k","r","/","s","h","o","p","c","a","s","t"];
    const cdn2_str = cdn2.join("");
    if(url.indexOf(cdn2_str) !== -1) return url.replace(cdn2_str, cdn_replace);


    const web = ["h","t","t","p",":","/","/","c","d","n",".","s","h","o","p","c","a","s","t",".","k","r","/","r","h","y","m","e","d","u","c","k"];
    const web_str = web.join("");
    const web_replace = ["/","p","r","x","-","w","e","b"].join("");
    if(url.indexOf(web_str) !== -1) return url.replace(web_str, web_replace);

    const web2 = ["h","t","t","p",":","/","/","c","d","n",".","r","h","y","m","e","d","u","c","k",".","c","o","m","/","r","h","y","m","e","d","u","c","k"];
    const web2_str = web2.join("");
    if(url.indexOf(web2_str) !== -1) return url.replace(web2_str, web_replace);

    return url;
}


// WEBPACK FOOTER //
// ./src/modules/func.js